<template>
  <div v-if="isShowDocumento">
    <v-divider class="mb-1"></v-divider>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar dense flat color="tertiary">
            <v-toolbar-title class="custon-toolbar-title">Listagem de Documentos</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text class="py-0">
            <v-data-table
              :headers="headers"
              :items="documentos"
              :item-key="documentos.id"
            >
              <template v-slot:item.acoes="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="toggleModalPdf(item.url_documento)"
                      fab
                      v-on="on"
                      depressed
                      x-small
                      color="indigo lighten-4"
                      class="mr-2"
                    >
                      <v-icon small color="indigo">mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>PDF</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="destroyFileConfirm(item)"
                      fab
                      v-on="on"
                      depressed
                      x-small
                      color="red lighten-4"
                    >
                      <v-icon color="red" small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Excluir Documento</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <ModalPdf />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import toastMessage, { confirmDestroyAlert } from '@/services/util/alertService';
import ModalPdf from '@/views/public/modal/Pdf.vue';

export default {
  name: 'ContratoDocumentoTable',
  components: { ModalPdf },
  data: () => ({
    headers: [
      {
        text: 'Nome',
        value: 'tipo_documento.nome',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'acoes',
        width: '12%',
        align: 'center',
        sortable: false,
      },
    ],
  }),
  methods: {
    ...mapActions('contrato', ['destroyFile']),
    ...mapActions('app', ['toggleModalPdf']),
    destroyFileConfirm(item) {
      confirmDestroyAlert(item.tipo_documento.nome)
        .then((result) => {
          if (result.value) {
            this.destroyFile({ contratoId: this.data.id, documentoId: item.id })
              .then(() => toastMessage.successDestroy('Documento excluído com sucesso'))
              .catch(() => toastMessage.errorDestroy('Erro ao excluir documento'));
          }
        });
    },
  },
  computed: {
    ...mapState('contrato', ['data']),
    isShowDocumento() {
      return Object.keys(this.data).length ? this.data.documentos.length : 0;
    },
    documentos() {
      return this.data.documentos;
    },
  },
};
</script>
